import { restClient } from '../../client';
import { InsuranceCompany } from '../../resources';


export const getInsuranceCompaniesSupportedByProviderAndPatient = (providerId: string) =>
  restClient.request<{
    data: InsuranceCompany[];
  }>('/api/v1/insurance/companies/for-provider-and-patient', {
    params: {
      provider_id: providerId,
    },
  });
